export enum CourseStatus {
	expired = 'expired',
	completed = 'completed',
	current = 'current',
}
